import { render } from "./HiDataList.vue?vue&type=template&id=1e4001d5"
import script from "./HiDataList.vue?vue&type=script&lang=js"
export * from "./HiDataList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__